function toggleMenu() {
  document.getElementById('mobileMenu').classList.toggle('open');
}
function closeMobile() {
  document.getElementById('mobileMenu').classList.remove('open');
}

/* ── Announcement bar (Early Bird) ── */
function dismissAnnouncementBar() {
  var bar = document.getElementById('announcementBar');
  if (bar) bar.style.display = 'none';
  try { sessionStorage.setItem('preshotAnnouncementDismissed', '1'); } catch (err) {}
}
(function () {
  try {
    if (sessionStorage.getItem('preshotAnnouncementDismissed') === '1') {
      document.addEventListener('DOMContentLoaded', function () {
        var bar = document.getElementById('announcementBar');
        if (bar) bar.style.display = 'none';
      });
    }
  } catch (err) {}
})();

/* ── Pre-Swing Fundamentals Video Library ── */
var YT_TOPICS = {
  alignment:    { label: "Alignment",             desc: "Aim the face, set your body parallel — train tracks to the target." },
  stance:       { label: "Stance & Foot Position", desc: "Width, foot flare, and a balanced base for every club." },
  distance:     { label: "Distance from Ball",     desc: "How far to stand — arm hang, posture, and setup checkpoints." },
  ballposition: { label: "Ball Position",          desc: "Where the ball sits in your stance, club by club." },
  shotshaping:  { label: "Shot Shaping",           desc: "Setup changes for draws, fades, and high or low flight." }
};

var YT_VIDEOS = [
  /* Alignment */
  { id:"z_PlY9OemuM", title:"Help With Your Alignment", channel:"Rick Shiels", cats:["alignment"] },
  { id:"_xbcQQNviFY", title:"How to Address the Ball \u2014 5 Key Check Points", channel:"Danny Maude", cats:["alignment","distance"] },
  { id:"CN3ThL8DgFM", title:"How to Play Golf \u2014 The Basics", channel:"Me and My Golf", cats:["alignment"] },
  { id:"lrAGc0_dzp0", title:"How to Aim in Golf \u2014 Face Aim + Body Lines", channel:"Mark Crossfield", cats:["alignment"] },
  { id:"koXQOutUm1s", title:"The Correct Way to Line Up a Shot", channel:"Peter Finch", cats:["alignment"] },

  /* Stance & Foot Position */
  { id:"iq5XvNtjv38", title:"How to Stand Correctly to the Golf Ball", channel:"Rick Shiels", cats:["stance","distance"] },
  { id:"7wT9c3ehFEM", title:"Golf Swing Basics \u2014 The Perfect Set Up", channel:"Me and My Golf", cats:["stance","distance"] },
  { id:"oandn2z-KwA", title:"Stance Fundamentals for Beginners", channel:"Mark Crossfield", cats:["stance"] },
  { id:"irrBGb5Eyaw", title:"Perfect Your Golf Stance", channel:"Mark Crossfield", cats:["stance"] },
  { id:"hd-4GShAwXY", title:"Stance and Ball Position \u2014 Start the Season Well", channel:"Peter Finch", cats:["stance","ballposition"] },

  /* Distance from Ball */
  { id:"SlVAm55HC_I", title:"How to Hit Good Golf Shots Consistently", channel:"Rick Shiels", cats:["distance"] },
  { id:"hhaam2N4obU", title:"The Perfect Set Up for Every Golf Shot", channel:"Me and My Golf", cats:["distance"] },
  { id:"2bn9AXMhaTw", title:"How to Stand to the Golf Ball \u2014 3-Step Iron Setup", channel:"Mark Crossfield", cats:["distance"] },

  /* Ball Position */
  { id:"lrZkQDOfxhs", title:"Ball Position by Club \u2014 Height and Launch", channel:"Mark Crossfield", cats:["ballposition"] },
  { id:"PNq90-aeqM8", title:"Perfect Ball Position Every Time", channel:"Peter Finch", cats:["ballposition"] },

  /* Shot Shaping */
  { id:"tGTLxIC66WE", title:"You MUST Learn These Golf Shots \u2014 Low, High, Fade, Draw", channel:"Rick Shiels", cats:["shotshaping"] },
  { id:"4CAMWevKkBU", title:"How to Draw & Fade Your Driver", channel:"Rick Shiels", cats:["shotshaping"] },
  { id:"P2cVTtKsirM", title:"How to Shape Any Golf Shot", channel:"Danny Maude", cats:["shotshaping"] },
  { id:"lwNeCfN5n8A", title:"How to Draw and Fade Your Golf Shots", channel:"Me and My Golf", cats:["shotshaping"] },
  { id:"rlE5cS__P50", title:"Shape Any Shot \u2014 Draw, Fade, Stinger, Straight", channel:"Peter Finch", cats:["shotshaping"] }
];

function ytPrimaryTag(v) {
  return YT_TOPICS[v.cats[0]] ? YT_TOPICS[v.cats[0]].label : '';
}

function ytMakeCard(v) {
  var card = document.createElement('div');
  card.className = 'video-card yt-card';
  card.innerHTML =
    '<div class="video-thumb yt-thumb" data-id="' + v.id + '">' +
      '<img src="https://img.youtube.com/vi/' + v.id + '/hqdefault.jpg" alt="' + v.title + '" loading="lazy">' +
    '</div>' +
    '<div class="video-info">' +
      '<span class="yt-tag">' + ytPrimaryTag(v) + '</span>' +
      '<h3>' + v.title + '</h3>' +
      '<p>' + v.channel + '</p>' +
    '</div>';
  var thumb = card.querySelector('.yt-thumb');
  thumb.addEventListener('click', function(){
    if (thumb.classList.contains('playing')) return;
    thumb.classList.add('playing');
    thumb.innerHTML = '<iframe src="https://www.youtube.com/embed/' + v.id + '?autoplay=1" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>';
  });
  return card;
}

function renderYT(filter) {
  var grid = document.getElementById('ytGrid');
  if (!grid) return;
  grid.innerHTML = '';

  if (filter === 'all') {
    /* Grouped view: one section per topic, each video shown once under its primary topic */
    Object.keys(YT_TOPICS).forEach(function(key){
      var vids = YT_VIDEOS.filter(function(v){ return v.cats[0] === key; });
      if (!vids.length) return;
      var header = document.createElement('div');
      header.className = 'yt-topic-header';
      header.innerHTML = '<h3>' + YT_TOPICS[key].label + '</h3><p>' + YT_TOPICS[key].desc + '</p>';
      grid.appendChild(header);
      vids.forEach(function(v){ grid.appendChild(ytMakeCard(v)); });
    });
  } else {
    /* Filtered view: any video tagged with this topic (primary or secondary) */
    var header = document.createElement('div');
    header.className = 'yt-topic-header';
    header.innerHTML = '<h3>' + YT_TOPICS[filter].label + '</h3><p>' + YT_TOPICS[filter].desc + '</p>';
    grid.appendChild(header);
    YT_VIDEOS.filter(function(v){ return v.cats.indexOf(filter) !== -1; })
      .forEach(function(v){ grid.appendChild(ytMakeCard(v)); });
  }
}

var ytFilters = document.getElementById('ytFilters');
if (ytFilters) {
  ytFilters.addEventListener('click', function(e){
    if (!e.target.classList.contains('filter-chip')) return;
    ytFilters.querySelectorAll('.filter-chip').forEach(function(b){ b.classList.remove('active'); });
    e.target.classList.add('active');
    renderYT(e.target.getAttribute('data-filter'));
  });
}
renderYT('all');
